import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

const useStyles = makeStyles({
    appbar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '20px 4px 18px',
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    mark: {
        width: '40px',
        height: '40px',
        borderRadius: '9px',
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        fontWeight: tokens.fontWeightBold,
        fontSize: '15px',
        letterSpacing: '0.5px',
        display: 'grid',
        placeItems: 'center',
        boxShadow: tokens.shadow2,
        flex: 'none',
    },
    meta: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: 1.2,
        minWidth: 0,
    },
    eyebrow: {
        fontSize: '11px',
        fontWeight: tokens.fontWeightSemibold,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: tokens.colorNeutralForeground3,
    },
    title: {
        fontSize: '20px',
        fontWeight: tokens.fontWeightBold,
        color: tokens.colorNeutralForeground1,
        letterSpacing: '-0.01em',
    },
    spacer: {
        flex: 1,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
});

interface BrandHeaderProps {
    eyebrow?: string;
    title: string;
    /** Right-aligned action buttons. */
    children?: ReactNode;
}

/** ATA-branded page header: navy "ATA" mark + eyebrow + title + actions. */
const BrandHeader = ({ eyebrow = 'Client Onboarding', title, children }: BrandHeaderProps) => {
    const styles = useStyles();

    return (
        <header className={styles.appbar}>
            <div className={styles.brand}>
                <div className={styles.mark} aria-hidden>
                    ATA
                </div>
                <div className={styles.meta}>
                    <span className={styles.eyebrow}>{eyebrow}</span>
                    <Text className={styles.title}>{title}</Text>
                </div>
            </div>
            <span className={styles.spacer} />
            {children && <div className={styles.actions}>{children}</div>}
        </header>
    );
};

export default BrandHeader;
